import { Partner, PartnerState } from './store'

export const SELECT_PARTNER = 'SELECT_PARTNER'

export type PartnerAction = { type: typeof SELECT_PARTNER; partner: Partner }

export function partnerReducer(state: PartnerState, action: PartnerAction) {
  switch (action.type) {
    case SELECT_PARTNER: {
      return {
        ...state,
        currentPartner: action.partner
      }
    }

    default: {
      return state
    }
  }
}
